import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getDirectReferralCount, { GetDirectReferralCountInput, GetDirectReferralCountOutput } from '.';

type TrimmedGetDirectReferralCountInput = Omit<GetDirectReferralCountInput, 'dlVaultContract'>;

export type UseGetDirectReferralCountQueryKey = [
  FunctionKey.GET_DIRECT_REFERRAL_COUNT,
  TrimmedGetDirectReferralCountInput,
];

type Options = QueryObserverOptions<
  GetDirectReferralCountOutput,
  Error,
  GetDirectReferralCountOutput,
  GetDirectReferralCountOutput,
  UseGetDirectReferralCountQueryKey
>;

const useGetDirectReferralCount = (input: TrimmedGetDirectReferralCountInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_DIRECT_REFERRAL_COUNT, input],
    () => getDirectReferralCount({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetDirectReferralCount; 